// extracted by mini-css-extract-plugin
export var blocker = "video-player-module--blocker--3ZHqA";
export var centerAndEnlargeVideo = "video-player-module--centerAndEnlargeVideo--EOO81";
export var embedBox = "video-player-module--embedBox--CZxaV";
export var fadeOut = "video-player-module--fadeOut--OBhPI";
export var videoFadeOut = "video-player-module--videoFadeOut--HeON8";
export var videoPad = "video-player-module--videoPad--7LhLe";